module.exports = __webpack_public_path__ + "img/M_Results_units.03e95513.svg";